<template>
  <div class="p-message-edit-condition-select-block">
    <div class="c-title">
      <div class="c-title__text">セグメントの条件を設定する</div>
    </div>
    <div class="p-message-edit-list__item">
      <div
        class="p-message-edit-select-condition"
        :class="classes.width.item"
      >
        <ul class="p-message-edit-select-condition-list">
          <li
            v-for="(baseCondition, index) in data.baseConditions"
            :key="'select-base-condition' + index"
            class="p-message-edit-select-condition-list__item"
          >
            <select-text
              ref="conditionSelect"
              input-name="message-select-condition-list"
              place-holder="配信条件を選択してください"
              :classes="[classes.width.selector, 'vc-zf35gktmw6']"
              :elements="selector.baseConditions[index]"
              :index="index"
              :is-error="index == 0 && isErrorBaseCondition && errorMessageBaseCondition && errorMessageBaseCondition != '' ? true : false"
              :error-message="index == 0 && isErrorBaseCondition && errorMessageBaseCondition && errorMessageBaseCondition != '' ? errorMessageBaseCondition : null"
              :value="data.baseConditions[index].id"
              :has-blank="true"
              @select="onSelectBaseCondition"
            />
            <button
              v-if="0 < index"
              type="button"
              class="c-btn c-btn--circle u-w30"
              @click="onClickDeleteBaseCondition(index)"
            >
              <div class="c-icon c-icon--gray-3 u-wh12">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#close" />
                </svg>
              </div>
            </button>
          </li>
        </ul>
        <button
          v-if="max.selector > totaSelectorNum && isNotSelectedItemByBaseCondition && isNotMaxSelectorNumBaseCondition"
          type="button"
          class="c-btn c-btn--block c-btn--add-condition"
          @click="onClickAddBaseCondition"
        >
          <div class="c-icon c-icon--gray-3 u-wh12">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#plus" />
            </svg>
          </div>
          さらに条件を追加する
        </button>
      </div>
      <div
        v-show="useTopicCondition()"
        class="p-message-edit-select-condition"
        :class="classes.width.item"
      >
        <ul class="p-message-edit-select-condition-list">
          <li
            v-for="(topicCondition, index) in data.topicConditions"
            :key="'select-topic-condition' + index"
            class="p-message-edit-select-condition-list__item"
          >
            <select-text
              ref="topicConditionSelect"
              input-name="message-select-topic-condition-list"
              place-holder="属性条件を選択してください"
              :classes="[classes.width.selector, 'vc-zf35gktmw6']"
              :elements="selector.topicConditions[index]"
              :index="index"
              :is-error="index == 0 && isErrorTopicCondition && errorMessageTopicCondition && errorMessageTopicCondition != '' ? true : false"
              :error-message="index == 0 && isErrorTopicCondition && errorMessageTopicCondition && errorMessageTopicCondition != '' ? errorMessageBaseCondition : null"
              :value="data.topicConditions[index].id"
              :has-blank="true"
              @select="onSelectTopicCondition"
            />
            <button
              v-if="0 < index"
              type="button"
              class="c-btn c-btn--circle u-w30"
              @click="onClickDeleteTopicCondition(index)"
            >
              <div class="c-icon c-icon--gray-3 u-wh12">
                <svg
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <use xlink:href="/assets/img/sprite.svg#close" />
                </svg>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import 'axios';
import store from "../../funcs/store.js";
export default {
  props: {
    baseConditions: { type: [Object, Array], required: true },
    baseConditionSourceTypes: { type: [Object, Array], required: true },
    initialData: { type: Object, required: false },
    isEnableTopicCondition: { type: Boolean, required: false },
    isEnableHybridCondition: { type: Boolean, required: false },
    onSelect: { type: Function, required: true },
    topicConditions: { type: [Object, Array] , required: true },
    width: { type: Number, required: false },
  },
  data: function () {
    return {
      classes: {
        width: {
          item: this.width ? `u-w${this.width}`  : '',
          selector: this.width ? `u-w${this.width - 40}` : '',
        }
      },
      errorMessage: '',
      errorMessageBaseCondition: '',
      errorMessageTopicCondition: '',
      data: {
        baseConditions: [{ id: null  }],
        topicConditions: [{ id: null }],
      },
      isError: false,
      isErrorBaseCondition: false,
      isErrorTopicCondition: false,
      max: {
        // セレクター最大追加数: 一応制限値として設定しいますが、制限値まで追加される事はないはずので、実質無制限になるはず
        // @TODO: 配信条件の追加数に制限を設ける場合は、ここの数値を調整
        selector: 99999,
        //selector: 3,
      },
      selector: {
        baseConditions: [
          this.baseConditions
        ],
        topicConditions: [
          this.topicConditions
        ],
      },
    };
  },
  computed: {
    // 選択済みの配信条件の総数
    totaSelectorNum: function () {
      return this.data.baseConditions.length + this.data.topicConditions.length;
    },

    // 基本条件の選択エリアの数が、選択肢の数以上か？
    isNotMaxSelectorNumBaseCondition: function () {
      return this.data.baseConditions.length < Object.keys(this.baseConditions).length;
    },

    // 属性条件の選択エリアの数が、選択肢の数以上か？
    isNotMaxSelectorNumTopicCondition: function () {
      return this.data.topicConditions.length < Object.keys(this.topicConditions).length;
    },

    // まだ、未選択の基本条件が存在するか？
    isNotSelectedItemByBaseCondition: function () {
      const selectedItems = this.data.baseConditions
        .filter((item) => item.id)
        .map((item) => item.id);
      const notSelectedItems = Object.keys(this.baseConditions).filter((key) => {
        return !selectedItems.some((item) => key == item);
      })
      return notSelectedItems.length > 0
    },

    // まだ、未選択の属性条件が存在するか？
    isNotSelectedItemByTopicCondition: function () {
      const selectedItems = this.data.topicConditions
        .filter((item) => item.id)
        .map((item) => item.id);
      const notSelectedItems = Object.keys(this.topicConditions).filter((key) => {
        return !selectedItems.some((item) => key == item);
      })
      return notSelectedItems.length > 0
    },

    // 選択済みの配信条件の総数
    selectedBaseConditionNum: function () {
      var count = 0;
      this.data.baseConditions.forEach((condition) => {
        if(condition.id){
          count++;
        }
      });
      return count;
    },

    // 選択済みの属性条件の総数
    selectedTopicConditionNum: function () {
      var count = 0;
      this.data.topicConditions.forEach((condition) => {
        if(condition.id){
          count++;
        }
      });
      return count;
    },

  },
  created: function () {
    // 初期セレクター情報作成
    const selector = {
      baseConditions: (this.initialData.baseConditions && this.initialData.baseConditions.length > 0)
        ? this.initialData.baseConditions.map((_item) => this.baseConditions)
        : [ this.baseConditions ],
      topicConditions: (this.initialData.topicConditions && this.initialData.topicConditions.length > 0)
        ? this.initialData.topicConditions.map((_item) => this.topicConditions)
        : [ this.topicConditions ],
    }
    this.selector = selector;

    // 初期選択値情報作成
    const selected = {
      baseConditions: (this.initialData.baseConditions && this.initialData.baseConditions.length > 0)
        ? this.initialData.baseConditions.map((item) => {
          return { id: item.condition_id };
        })
        : [{ id: null  }],
      topicConditions: (this.initialData.topicConditions && this.initialData.topicConditions.length > 0)
        ? this.initialData.topicConditions.map((item) => {
          return { id: item.topic_condition_id.toString() };
        })
        : [{ id: null  }],
    };
    this.data = selected;

    //
    // 初期セレクター情報と初期選択情報を作成後、選択値にあわせてセレクターを更新
    //
    // 選択結果に基づき、全てのセレクター情報を更新
    this.selector.baseConditions.forEach((_selector, index) => {
      this.selector.baseConditions[index] = this.getSelectorBaseCondition(index)
    })

    // 選択結果に基づき、全てのセレクター情報を更新
    this.selector.topicConditions.forEach((_selector, index) => {
      this.selector.topicConditions[index] = this.getSelectorTopicCondition(index)
    })
  },
  methods: {
    getSelectorBaseCondition(index) {
      const keys = Object.keys(this.baseConditions).filter((key) => {
        const isSelected = this.data.baseConditions.some((item, selectedIndex) => {
          if (index == selectedIndex) return false;
          if (item.id && item.id == key) return true;
          return false;
        })
        return !isSelected;
      })

      const selector = {}
      keys.forEach((key) => {
        selector[key] = this.baseConditions[key];
      })

      return selector
    },

    getSelectorTopicCondition(index) {
      const keys = Object.keys(this.topicConditions).filter((key) => {
        const isSelected = this.data.topicConditions.some((item, selectedIndex) => {
          if (index == selectedIndex) return false;
          if (item.id && item.id == key) return true;
          return false;
        })
        return !isSelected;
      })

      const selector = {}
      keys.forEach((key) => {
        selector[key] = this.topicConditions[key];
      })

      return selector
    },

    // セレクター追加: 基本条件
    onClickAddBaseCondition() {
      //
      // 配信条件の追加制限が閾値を超過する場合はエラーメッセージを表示して処理終了
      // * 基本的に制限未満の場合のみ追加ボタンは表示されるので、ありえないが念のため検証
      //
      if (this.max.selector <= this.totaSelectorNum) {
        this.isError = true;
        this.errorMessage = `配信条件は最大で${this.max.selector}個までしか、追加する事はできません`;
        return;
      }
      this.data.baseConditions.push({'index': this.data.baseConditions.length});
      this.selector.baseConditions.push(this.getSelectorBaseCondition(this.data.baseConditions.length));
    },

    // セレクター追加: 属性条件
    onClickAddTopicCondition() {
      //
      // 配信条件の追加制限が閾値を超過する場合はエラーメッセージを表示して処理終了
      // * 基本的に制限未満の場合のみ追加ボタンは表示されるので、ありえないが念のため検証
      //
      if (this.max.selector <= this.totaSelectorNum) {
        this.isError = true;
        this.errorMessage = `配信条件は最大で${this.max.selector}個までしか、追加する事はできません`;
        return;
      }
      this.data.topicConditions.push({});
      this.selector.topicConditions.push(this.getSelectorTopicCondition(this.data.topicConditions.length));
    },

    // セレクター削除: 基本条件
    onClickDeleteBaseCondition(index) {
      // index番号が0の場合は処理終了
      if (index < 1) return;

      // 指定のindex番号の選択データを削除
      if (this.data.baseConditions[index]) {
        this.data.baseConditions.splice(index, 1);
      };

      // 指定のindex番号のセレクターを削除
      if (this.selector.baseConditions[index]) {
        this.selector.baseConditions.splice(index, 1);
      };

      // 選択結果に基づき、全てのセレクター情報を更新
      this.selector.baseConditions.forEach((_selector, index) => {
        this.selector.baseConditions[index] = this.getSelectorBaseCondition(index)
      })

      // 親コンポーネントに選択データをエミット
      this.onSelect(this.data.baseConditions, this.data.topicConditions);
    },

    // セレクター削除: 属性条件
    onClickDeleteTopicCondition(index) {
      // index番号が0の場合は処理終了
      if (index < 1) return;

      // 指定のindex番号の選択データを削除
      if (this.data.topicConditions[index]) {
        this.data.topicConditions.splice(index, 1);
      };

      // 指定のindex番号のセレクターを削除
      if (this.selector.topicConditions[index]) {
        this.selector.topicConditions.splice(index, 1);
      };

      // 選択結果に基づき、全てのセレクター情報を更新
      this.selector.topicConditions.forEach((_selector, index) => {
        this.selector.topicConditions[index] = this.getSelectorTopicCondition(index)
      })

      // 親コンポーネントに選択データをエミット
      this.onSelect(this.data.baseConditions, this.data.topicConditions);
    },

    // セレクター選択: 基本条件
    onSelectBaseCondition(selected, index) {
      // 指定のindex番号の選択データが存在しない場合は処理終了
      if (!this.data.baseConditions[index]) return false;

      // 混合条件が許可されていない場合はチェックする
      if(!this.isEnableHybridCondition){
        if(this.selectedTopicConditionNum > 0){
          this.$refs.conditionSelect[index].clearValue();
          this.isError = true;
          this.errorMessage = `配信条件と属性条件を同時に指定できるのは予約配信のみです`;
          return false;
        }
      }

      // 指定のindex番号の選択データを更新
      this.data.baseConditions[index].id = selected;

      // 選択結果に基づき、全てのセレクター情報を更新
      this.selector.baseConditions.forEach((_selector, index) => {
        this.selector.baseConditions[index] = this.getSelectorBaseCondition(index)
      })

      // エラーメッセージのリセット
      this.isErrorBaseCondition = false;
      this.errorMessageBaseCondition = '';
      this.isErrorTopicCondition = false;
      this.errorMessageTopicCondition = '';

      // 親コンポーネントに選択データをエミット
      this.onSelect(this.data.baseConditions, this.data.topicConditions);
    },

    // セレクター選択: 属性条件
    onSelectTopicCondition(selected, index) {
      // 指定のindex番号の選択データが存在しない場合は処理終了
      if (!this.data.topicConditions[index]) return false;

      // 混合条件が許可されていない場合はチェックする
      if(!this.isEnableHybridCondition){
        if(this.selectedBaseConditionNum > 0){
          this.$refs.topicConditionSelect[index].clearValue();
          this.isError = true;
          this.errorMessage = `配信条件と属性条件を同時に指定できるのは予約配信のみです`;
          return false;
        }
      }

      // 指定のindex番号の選択データを更新
      this.data.topicConditions[index].id = selected;

      // 選択結果に基づき、全てのセレクター情報を更新
      this.selector.topicConditions.forEach((_selector, index) => {
        this.selector.topicConditions[index] = this.getSelectorTopicCondition(index)
      })

      // エラーメッセージのリセット
      this.isErrorBaseCondition = false;
      this.errorMessageBaseCondition = '';
      this.isErrorTopicCondition = false;
      this.errorMessageTopicCondition = '';

      // 親コンポーネントに選択データをエミット
      this.onSelect(this.data.baseConditions, this.data.topicConditions);
    },

    setErrorBaseCondition(message) {
      if (!message || message == '') return false;
      this.isErrorBaseCondition = true;
      this.errorMessageBaseCondition = message;
    },

    setErrorTopicCondition(message) {
      if (!message || message == '') return false;
      this.isErrorTopicCondition = true;
      this.errorMessageTopicCondition = message;
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    useTopicCondition: function() {
      return store.getServiceTypes().includes('2');
    },
  },
}
</script>
